"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneSmallOutlineNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneSmallOutlineNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.937 2c.414 0 .75.337.75.75v1.025c0 .2-.078.389-.22.53l-.917.919a1.646 1.646 0 0 0-.367 1.797 8.94 8.94 0 0 0 4.796 4.797c.197.081.406.122.62.122.437 0 .866-.178 1.178-.49l.918-.918c.14-.14.332-.22.53-.22h1.025a.75.75 0 0 1 .75.75v1.313c0 .896-.736 1.625-1.643 1.625C6.647 13.99 2 9.336 2 3.625 2 2.73 2.73 2 3.625 2h1.312Zm0-1H3.625A2.625 2.625 0 0 0 1 3.625C1 9.901 6.082 14.99 12.355 15h.005A2.635 2.635 0 0 0 15 12.375v-1.312a1.75 1.75 0 0 0-1.75-1.75h-1.026c-.464 0-.909.184-1.237.512l-.918.918a.67.67 0 0 1-.47.197.615.615 0 0 1-.237-.046 7.889 7.889 0 0 1-4.256-4.256.654.654 0 0 1 .15-.707l.919-.918a1.75 1.75 0 0 0 .512-1.238V2.75A1.75 1.75 0 0 0 4.937 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneSmallOutlineNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneSmallOutlineNo;
exports["default"] = _default;